import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import {
  vehiclesQuery,
  vehicleMakesQuery,
  vehicleDetailsQuery,
  overrideOwnershipMutation,
} from './queries'

export const fetchVehicles = (varObject) => (dispatch) => {
  return request(vehiclesQuery.default, varObject)
    .then((response) => {
      dispatch({
        type: 'FETCH_VEHICLES_SUCCESS',
        entities: response.data.data.vehicles.items,
        meta: response.data.data.vehicles.meta,
        makes: response.data.data.vehicles.meta.makes,
        models: response.data.data.vehicles.meta.models,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_VEHICLES_FAILURE',
      })
      dispatch(displayNotification('Failed to fetch Vehicles', 'error', 10000))
    })
}

export const fetchAllVehicles = () => (dispatch) => {
  return request(vehiclesQuery.default, {})
    .then((response) => {
      dispatch({
        type: 'FETCH_VEHICLE_FACETS_SUCCESS',
        makes: response.data.data.vehicles.meta.makes,
        models: response.data.data.vehicles.meta.models,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_VEHICLE_FACETS_FAILURE',
      })
      dispatch(
        displayNotification('Failed to fetch all Vehicles', 'error', 5000)
      )
    })
}

export const fetchVehicle = (id) => (dispatch) => {
  return request(vehicleDetailsQuery.default, { id })
    .then((response) => {
      const vehicle = response.data.data.vehicle
      dispatch({
        type: 'FETCH_VEHICLE_SUCCESS',
        entity: vehicle,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_VEHICLE_FAILURE',
      })
      dispatch(displayNotification('Failed to fetch Vehicle', 'error'))
    })
}

export const fetchMakes = () => (dispatch) => {
  return request(vehicleMakesQuery.default, {})
    .then((response) => {
      const makes = response.data.data.vehicleMakes.items
      dispatch({
        type: 'FETCH_MAKES_SUCCESS',
        entities: makes,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_MAKES_FAILURE',
      })
    })
}

export const fetchModels = (input) => (dispatch) => {
  return request(vehiclesQuery.default, { make: input })
    .then((response) => {
      const models = response.data.data.vehicles.meta.models
      dispatch({
        type: 'FETCH_MODELS_SUCCESS',
        entities: models,
      })
    })
    .catch(() => {
      dispatch({
        type: 'FETCH_MODELS_FAILURE',
      })
    })
}

export const overrideOwnership = (userId, vehicleId) => (dispatch) => {
  return request(overrideOwnershipMutation.default, {
    OverrideOwnershipInput: { userId, vehicleId },
  })
    .then((res) => {
      if (res.data.errors) {
        throw new Error(res.data.errors[0].message)
      } else {
        const vehicle = res.data.data.overrideOwnership.ownership.vehicle
        dispatch({
          type: 'UPDATE_VEHICLE_SUCCESS',
          entity: vehicle,
        })
      }
    })
    .catch((err) => {
      dispatch({
        type: 'UPDATE_VEHICLE_FAILURE',
      })
      dispatch(displayNotification(`${err.message}`, 'error'))
      throw new Error(err)
    })
}
